<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle" v-if="lang_cm != 'greek'">
      {{ getCategoryTitle(lang_cm) }}
    </h1>
    <h1 class="main_title white lg content" id="contentTitle" v-else>
      {{ getCategoryTitle(lang_cm) }}
    </h1>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class= "mobiTitle md text_color" v-if="lang_cm != 'greek'">
            <span>{{ $t("category") }} - {{ getCategoryTitle(lang_cm) }}</span>
          </h2>
          <h2 class= "main_title md text_color" v-else>
            <span>{{ $t("category") }} - {{ getCategoryTitle(lang_cm) }}</span>
          </h2>
        </div>
        <div class="mobiSection__content">
          <div v-if="isLoaded.subCategory === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="mobislider" v-if="isLoaded.subCategory === true">
            <cutemobi-slider
              :sliderData="subcategory"
              :cat="cat.sub"
              :category="category"
              ref="childComponent"
            ></cutemobi-slider>
          </div>
        </div>
      </div>
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="HotPickIcon_cm" alt="" />
            <span class="text_color">{{ $t("hotpicks") }}</span>
          </h2>
        </div>
        <div class="mobiSection__content">
          <div v-if="isLoaded.hotpicks === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="sliderWrap" v-if="isLoaded.hotpicks === true">
            <cutemobi-slider
              :hotpick="hotpicks"
              :cat="cat.hot"
              :category="category"
              ref="hotPickComponent"
            ></cutemobi-slider>
          </div>
        </div>
      </div>
      <div class="mobiSection">
        <div class="mobiSection__header">
          <h2 class="mobiTitle md">
            <img class="mobiIcon" :src="PopularIcon_cm" alt="" />
            <span class="text_color">{{ $t("popular") }}</span>
          </h2>
        </div>
        <div class="mobiSection__content">
          <div v-if="isLoaded.popular === false">
            <svg class="spinner" viewBox="0 0 50 50">
              <circle
                class="path"
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke-width="5"
              ></circle>
            </svg>
          </div>
          <div class="sliderWrap" v-if="isLoaded.popular === true">
            <cutemobi-slider
              :popular="popular"
              :cat="cat.pop"
              :category="category"
              ref="popularComponent"
            ></cutemobi-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { mapGetters } from "vuex";
import CutemobiSlider from "../CutemobiSlider.vue";
import country_list from "../../../locales/country_list.json";
import StarRating from 'vue-star-rating';
// Vue.component("star-rating", VueStarRating.default);
const currentDate = new Date();
let day = currentDate.getDay();

export default {
  data() {
    return {
      category: "",
      categoryTranslate: "",
      subcategory: {},
      hotpicks: {},
      popular: {},
      cat: {
        hot: "hot",
        pop: "pop",
        sub: "sub",
      },
      isLoaded: {
        hotpicks: false,
        popular: false,
        subCategory: false,
        subCategoryAr: false,
      },
    };
  },
  computed: mapGetters([
    "HotPickIcon_cm",
    "PopularIcon_cm",
    "lang_cm",
    "country_cm",
    "host_cm",
  ]),
  components: {
    "cutemobi-slider": CutemobiSlider,
    "star-rating": StarRating
  },
  created() {
    let c = this.$route.params.category;
    //if route have '_' will change to space
    let cat = c.replace("_", " ");
    //split category name and category id
    let cate = cat.split("-");
    this.category = cate[0];

    this.getCatHotPicks(cate[0]);
    this.getCatPopular(cate[0]);
    this.getSubcategory(cate[0], cate[1]);
  },
  methods: {
    async getCatHotPicks(category) {
      let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=100&offset=0&domain=${this.host_cm}`;
      let live = `http://cook.grabmobi.com/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=100&offset=0&domain=${this.host_cm}`;
      await axios.get(live).then((res) => {
          let data = res.data.data;
          data.sort(function (a, b) {
            //to sort random
            return 0.5 - Math.random();
          });

          this.isLoaded.hotpicks = true;

          this.hotpicks = data.slice(0,10);
          setTimeout(() => {
            this.$refs.hotPickComponent.triggerFn("hotPicksSlider");
          }, 0);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCatPopular(category) {
      let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=100&offset=0&domain=${this.host_cm}`;
      let live = `http://cook.grabmobi.com/api/contents/cutemobi_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${category}&limit=100&offset=0&domain=${this.host_cm}`;
      await axios.get(live).then((res) => {
          let data = res.data.data;
          data.sort(function (a, b) {
            //to sort random
            return 0.5 - Math.random();
          });

          this.isLoaded.popular = true;

          this.popular = data.slice(0,10);
          setTimeout(() => {
            this.$refs.popularComponent.triggerFn("popularSlider");
          }, 0);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSubcategory(category, id) {
      let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=${category}&subcategory=${id}&limit=100&offset=0&domain=${this.host_cm}`;
      let live = `http://cook.grabmobi.com/api/contents/cutemobi?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=${category}&subcategory=${id}&limit=100&offset=0&domain=${this.host_cm}`;
      axios.get(live)
        .then((res) => {
          let data = res.data.data;
          let temp_data = data.map((item) => {
            let cat_trans = [];
            let sub_trans = [];
            if (item.category_translate != null) {
              cat_trans = JSON.parse(item.category_translate);
            }
            if (item.subcategory_translate != null) {
              sub_trans = JSON.parse(item.subcategory_translate);
            }

            item.titleSub_english = item.subcategory;
            item.route = item.subcategory;
            if (cat_trans != null && cat_trans != "") {
              if (this.lang_cm != "english") {
                this.categoryTranslate = cat_trans[this.lang_cm].title;
                if (sub_trans != null) {
                  item["titleSub_" + this.lang_cm] =
                    sub_trans[this.lang_cm].title;
                }
              } else {
                for (let [key, value] of Object.entries(country_list)) {
                  if (this.country_cm == key) {
                    if (value.language != "english") {
                      this.categoryTranslate =
                        cat_trans[`${value.language}`].title;
                      if (sub_trans != null) {
                        item[`titleSub_${value.language}`] =
                          sub_trans[`${value.language}`].title;
                      }
                    }
                  } else {
                    item.titleSub_english = item.subcategory;
                  }
                }
              }
            }

            if (item.subcategory_icon != null) {
              let sub_icon = JSON.parse(item.subcategory_icon);
              if (sub_icon != null) {
                for (let [key, value] of Object.entries(sub_icon)) {
                  if (key == this.host_cm) {
                    item.icon = sub_icon[key]["class"];
                  } else {
                    item.icon = sub_icon["cutemobi.vip"]["class"];
                  }
                }
              }
            }
            return item;
          });

          this.isLoaded.subCategory = true;
          this.subcategory = temp_data;

          setTimeout(() => {
            this.$refs.childComponent.triggerFn("catSlider");
          }, 100);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryTitle(lang) {
      if (lang == "english") {
        return this.category;
      }
      if (lang != "english") {
        return this.categoryTranslate;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main_title {
  margin: 0;
  line-height: 1.1;
  /* text-transform: capitalize; */
  word-break: break-word;
  color: #000;
}
.main_title.lg{
  font-size: 3rem;
}
.main_title.content{
  padding: 25px 30px;
}
.main_title.white{
  color: white;
}
.main_title.md{
  font-size: 1.4rem;
  font-weight: 600;
}

.subTitle {
  color: black;
  text-transform: capitalize;
}

.browse_link {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/cutemobi/browse/Category.vue